import React from 'react';
import Header from './../Common/Header';
import Slider from './../Elements/Slider';
import Footer from './../Common/Footer';
import { DEFAULT_IMAGE_DELAY_MS } from '../../config/performance';
import Specialization from './../Elements/Specialization';
import About from './../Elements/About';
import OurValue from './../Elements/OurValue';
import OurMission from './../Elements/OurMission';
import OurServices from './../Elements/OurServices';
import Callus from './../Elements/Callus';
import OurProject from './../Elements/OurProject';
import Blogs from './../Elements/Blogs';
import Testimonials from './../Elements/Testimonials';

class Home extends React.Component {
    render() {
        return (
            <>
                <Header transparent />
                <div className="page-content">
                    <Slider delayMs={DEFAULT_IMAGE_DELAY_MS} />
                    <Specialization />
                    <About />
                    <OurValue />
                    <OurMission />
                    <OurServices />
                    <Callus />
                    <OurProject />
                    <Blogs />
                    <Testimonials />
                </div>
                <Footer />
            </>
        );
    };
};

export default Home;